import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/feature/cartReducer";
import "./shoppingCard.css";
import AOS from "aos";
import "aos/dist/aos.css";

import { Modal, Image } from "react-bootstrap";

const ShoppingCard = ({ item }) => {
  const { title, price, image, id, description, category } = item;

  const dispatch = useDispatch();
  const quantity = useSelector((state) => state.cart.totalQuantity);

  const [showModal, setShowModal] = useState(false);
  const [animationClass, setAnimationClass] = useState("");

  useEffect(() => {
    AOS.init({ duration: 500 });
  }, []);

  const handleImgClick = () => {
    setAnimationClass("animate__animated animate__zoomIn");
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setAnimationClass("animate__animated animate__zoomOut");
    setTimeout(() => {
      setShowModal(false);
      setAnimationClass("");
    }, 500);
  };

  const handleAddToCart = () => {
    const data = { id, title, price, image, quantity };
    dispatch(addToCart(data));
  };

  return (
    <div data-aos={"fade-up"} className="shopping-card mt-5" id="shopping-card">
      <img
        className="shopping-img"
        src={image}
        alt={title}
        onClick={handleImgClick}
      />
      <p className="shopping-price"> ${price} </p>
      {/* <div className="detail">
        <h6 className="detail-title">{title}</h6>
        <p className="detail-category">{category}</p>

        <div>
          <p className="detail-desc">
            {description?.slice(0, 130).concat("..")}
          </p>
        </div>
      </div> */}

      <div className="d-flex">
        <button onClick={handleAddToCart} className="mobile-shopping-btn">
          Add to
          <i className="icon-basket fas fa-regular fa-bag-shopping"></i>
        </button>
      </div>
      {showModal && (
        <Modal
          className={`mobile-boot-modal ${animationClass}`}
          show={showModal}
          onHide={handleCloseModal}
        >
          <Modal.Title>
            <button
              onClick={handleCloseModal}
              type="button"
              className="mobile-modal-close-button"
            >
              <i className="fas fa-times"></i>
            </button>
          </Modal.Title>

          <Modal.Body className="mobile-shopping-modal-content">
            <Image
              className="mobile-shopping-modal-img"
              src={image}
              alt={title}
              fluid
            />
            <div className="mobile-detail">
              <p className="mobile-detail-price">${price}</p>
              <h6 className="mobile-detail-title">{title}</h6>
              <p className="mobile-detail-category">{category}</p>

              <div>
                <p className="mobile-detail-desc">
                  {description?.slice(0, 370).concat("..")}
                </p>
              </div>
            </div>
            <button onClick={handleAddToCart} className="mobile-modal-add-btn">
              Add to
              <i className="icon-basket fas fa-regular fa-bag-shopping"></i>
            </button>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default ShoppingCard;
